module.exports = __webpack_public_path__ + "assets/4-Talent-Acquisition-Specialists.32ddeef8.png";